





































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { apiService, AppConstants, Interfaces } from "@/core/Export";
import store from "@/store";
@Component
export default class AppHeader extends Vue {
  @Prop() onSetRightDrawerState: Function;
  @Prop({ required: false, default: false }) useReports: boolean;
  isInSaveProcess: boolean;
  isMultipleEmployeesAttendReportApprovalDialogVisible: boolean;
  multipleAttendReportApprovalSummary: any;
  multipleAttendReportApprovalSummaryMsgs: Array<any>;
  $q;

  constructor() {
    super();
    this.isInSaveProcess = false;
    this.isMultipleEmployeesAttendReportApprovalDialogVisible = false;
    this.multipleAttendReportApprovalSummary = null;
    this.multipleAttendReportApprovalSummaryMsgs = [];
  }

  onGetEmployeeFields() {
    let arr = new Array<string>();
    if (this.currentEmployee.idNo) {
      arr.push(`${this.$t("fields.idNo")}: ${this.currentEmployee.idNo}`);
    }

    if (this.currentEmployee.salaryNo) {
      arr.push(
        `${this.$t("fields.salaryNo")}: ${this.currentEmployee.salaryNo}/${this.currentEmployee.salaryFactoryNo
        }`
      );
    }

    if (this.currentEmployee.orgStructName) {
      arr.push(
        `${this.$t("fields.orgStructId")}: ${this.currentEmployee.orgStructName
        }`
      );
    }

    if (this.currentEmployee.jobTypeName) {
      arr.push(
        `${this.$t("fields.jobTypeName")}: ${this.currentEmployee.jobTypeName}`
      );
    }

    if (this.currentEmployee.phoneNo) {
      arr.push(`${this.$t("fields.phoneNo")}: ${this.currentEmployee.phoneNo}`);
    }

    return arr.join(" | ");
  }

  onActivateReportsDrawer() {
    if (this.currentSelectedEmployees.length > 0) {
      store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
      store.commit(
        AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
        AppConstants.DrawerComponnents.Reports
      );
    } else {
      this.appEnv.showErrorDialog([
        { message: this.$t("msgs.reportEmpNotChoosen") },
      ]);
    }
  }

  onActivateApprovalsList() {
    let employeeId =
      this.currentActingEmployeeId == 0
        ? this.appEnv.UserInfo.employeeId
        : this.currentActingEmployeeId;
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(
      AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
      AppConstants.DrawerComponnents.ApprovalsList
    );
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {
      employeeId: employeeId,
      isFromManager: true,
    });
  }

  get currentActingEmployeeId() {
    return store.getters.currentActingEmployeeId;
  }

  onApproveMultipleEmployeesAttendReports() {
    if (this.currentSelectedEmployees.length > 0) {
      this.$q
        .dialog({
          title: this.$t("verification"),
          message: this.$t("msgs.manager_sign_multiple_employees_verify"),
          cancel: this.$t("reject"),
          ok: this.$t("approve"),
          persistent: true,
          html: false,
          focus: "none",
          class: "health_declaration_dialog",
        })
        .onOk(() => {
          let employeesIds = this.currentSelectedEmployees.map((s) => s.id);
          this.multipleAttendReportApprovalSummary = null;
          this.multipleAttendReportApprovalSummaryMsgs = [];
          this.isInSaveProcess = true;
          this.appEnv.isBusy = true;
          apiService
            .saveMultipleEmployeesAttendReportApproval(
              employeesIds,
              this.selectedYear,
              this.selectedMonth
            )
            .then((res) => {
              let result = res as Interfaces.iServiceRequest;
              let call = result.calls[0] as Interfaces.iServiceCall;
              if (call && call.isSuccess) {
                this.multipleAttendReportApprovalSummaryMsgs = call.msgs.msgs;
                this.multipleAttendReportApprovalSummary = call.callResult.data;
                this.isMultipleEmployeesAttendReportApprovalDialogVisible = true;
                if (this.multipleAttendReportApprovalSummary && this.multipleAttendReportApprovalSummary.totalSuccessEmployees > 0) {
                  this.onGetManagerEmployees();
                }
              }
            })
            .finally(() => {
              this.isInSaveProcess = false;
              this.appEnv.isBusy = false;
            });
        })
        .onCancel(() => { });
    } else {
      this.appEnv.showErrorDialog([
        {
          message: this.$t(
            "msgs.approve_multiple_employees_attend_reports_not_choosen"
          ),
        },
      ]);
    }
  }

  onGetManagerEmployees() {
    this.appEnv.isBusy = true;
    apiService
      .getManagerEmployees(this.selectedYear, this.selectedMonth, this.currentActingEmployeeId)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          store.commit(
            AppConstants.StoreMutations.UpdateEmployeesList,
            call.callResult.data
          );
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onPreviousEmployee() {
    let previousEmployee =
      this.employeesList[this.employeesList.indexOf(this.currentEmployee) - 1];
    if (previousEmployee) {
      this.currentEmployee = previousEmployee;
    }
  }

  onNextEmployee() {
    let nextEmployee =
      this.employeesList[this.employeesList.indexOf(this.currentEmployee) + 1];
    if (nextEmployee) {
      this.currentEmployee = nextEmployee;
    }
  }

  onGoBack() {
    this.$router.go(-1);
  }

  get isManagerSignMultipleEmpAttendReportsButtonVisible() {
    return (
      this.$route.name == AppConstants.Routes.M_Employees &&
      this.appEnv.UserInfo.isManager &&
      this.appEnv.isAllowed(
        AppConstants.Permissions.PortalMngrSignOnMultipleAttendReports
      )
    );
  }

  isVisibleBtnManagerSignMultipleEmp() {
    if (this.selectedYear > this.appEnv.UserInfo.currentYear) return false;
    if (
      this.selectedMonth < this.appEnv.UserInfo.currentMonth ||
      this.selectedYear < this.appEnv.UserInfo.currentYear
    )
      return true;
    return false;
  }

  get isApprovalsButtonVisible() {
    return (
      this.$route.name == AppConstants.Routes.M_Employees &&
      this.appEnv.UserInfo.isManager
    );
  }

  get isReportsButtonVisible() {
    return (
      this.$route.name == AppConstants.Routes.M_Employees &&
      this.appEnv.UserInfo.isManager &&
      this.appEnv.isAllowed(AppConstants.Permissions.CanSeeReports)
    );
  }

  get isEmployeePersoanlAreaToolBarVisible() {
    return (
      this.$route.name == AppConstants.Routes.M_PersonalArea ||
      this.$route.name == AppConstants.Routes.E_PersonalArea
    );
  }

  get isEmployeeDetailsToolBarVisible() {
    return (
      this.$route.name == AppConstants.Routes.M_Employee_Details &&
      this.appEnv.UserInfo.isManager
    );
  }

  get isPreviousEmployeeButtonActive() {
    return this.currentEmployeeNumber == 1;
  }

  get isNextEmployeeButtonActive() {
    return this.currentEmployeeNumber == this.totalEmployees;
  }

  get employeePageintion() {
    if (this.$q.screen.xs) {
      return `${this.currentEmployeeNumber}/${this.totalEmployees}`;
    } else {
      return `${this.$t("employee")} ${this.currentEmployeeNumber} ${this.$t(
        "from"
      )} ${this.totalEmployees}`;
    }
  }

  get currentEmployeeNumber() {
    let index = this.employeesList.indexOf(this.currentEmployee);
    return index + 1;
  }

  get totalEmployees() {
    return this.employeesList.length;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  set currentEmployee(value) {
    store.commit(AppConstants.StoreMutations.UpdateCurrentEmployee, value);
  }

  get employeesList() {
    return store.getters.employeesList;
  }

  get currentSelectedEmployees() {
    return store.state.currentSelectedEmployees;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get appEnv() {
    return store.state.appEnv;
  }
}
